import React from "react";
import { useTranslation } from "react-i18next";
import Energy from "../../assets/smart-formulas/energy.webp";
import Stress from "../../assets/smart-formulas/stress.webp";
import Sleep from "../../assets/smart-formulas/sleep.webp";
import Beauty from "../../assets/smart-formulas/beauty.webp";
import ImmuneSystem from "../../assets/smart-formulas/immune-system.webp";
import Performance from "../../assets/smart-formulas/sport.webp";
import QuizPage from "../../assets/smart-formulas/quiz-page.png";
import CustomLink from "../CustomLink";
import { Icon } from "../elements/icon";
import {
  ProductsHeader,
  ExploreSmartFormulas,
  NeedHelp,
  Take5MinQuiz,
  Days,
} from "../../Constants";

const Products = () => {
  const { t } = useTranslation();
  const data = [
    {
      name: "Energy",
      image: Energy,
      price: 49,
      href: "/products/energy",
    },
    {
      name: "Immune System",
      image: ImmuneSystem,
      price: 39,
      href: "/products/immune-system",
    },
    {
      name: "Beauty",
      image: Beauty,
      price: 32,
      href: "/products/beauty",
    },
    {
      name: "Stress",
      image: Stress,
      price: 59,
      href: "/products/stress",
    },
    {
      name: "Performance",
      image: Performance,
      price: 69,
      href: "/products/performance",
    },
    {
      name: "Sleep",
      image: Sleep,
      price: 49,
      href: "/products/sleep",
    },
  ];
  return (
    <>
      <div className="container t-flex t-items-center t-pt-8 t-gap-1">
        <CustomLink to="/" className="t-text-gray-400 t-text-lg">
          Home
        </CustomLink>
        <p className="!t-m-0 t-text-gray-400 t-text-lg">/</p>
        <p className="!t-m-0 t-text-gray-400 t-text-lg">Products</p>
      </div>
      <div className="t-bg-gray-100 t-py-4 t-my-4">
        <div className="container t-flex t-items-start md:t-items-center t-gap-4">
          <img
            src={QuizPage}
            alt=""
            className="t-w-[35%] md:t-w-[250px] t-h-auto t-max-h-[300px] t-rounded-lg"
          />
          <div className="t-w-full t-mx-auto t-flex t-flex-col t-gap-8">
            <h2 className="t-text-[24px] md:t-text-[30px] t-text-tertiary !t-break-all">
              {t(ProductsHeader)}
            </h2>
            <CustomLink
              to="/quiz"
              className="!t-w-12 !t-h-12 t-bg-secondary !t-rounded-full t-flex t-items-center t-justify-center t-ml-auto"
            >
              <Icon name="chevronRight" color="#fff" size="32" />
            </CustomLink>
          </div>
        </div>
      </div>
      <div className="container t-flex t-flex-col t-gap-2 t-py-4">
        <h2 className="t-text-[24px] md:t-text-[30px] t-font-bold t-text-tertiary">
          {t(ExploreSmartFormulas)}
        </h2>
        <div className="t-grid t-grid-cols-2 md:t-grid-cols-3 t-gap-4">
          {data.map((item) => (
            <CustomLink
              to={item.href}
              key={"product-" + item.name}
              className="t-flex t-flex-col t-gap-2"
            >
              <img src={item.image} alt="" />
              <div>
                <h1
                  className="t-text-black !t-m-0 t-font-extrabold t-text-center"
                  style={{ fontFamily: "Roboto" }}
                >
                  {item.name}
                </h1>
                <div className="t-flex t-items-center t-justify-center">
                  <h2 className="t-text-secondary">{item.price}€ </h2>
                  <p className="!t-m-0 t-text-gray-400 !t-ml-1">
                    {" "}
                    (30 {t(Days)})
                  </p>
                </div>
              </div>
            </CustomLink>
          ))}
        </div>
      </div>
      <div className="t-flex t-flex-col t-gap-8 t-bg-gray-100 t-px-4 t-py-8">
        <div className="t-w-full t-max-w-[800px] t-mx-auto t-flex t-flex-col t-gap-8">
          <h2 className="t-text-[24px] md:t-text-[30px] !t-text-center t-text-tertiary">
            {t(NeedHelp)}
          </h2>
          <CustomLink
            to="/quiz"
            className="!t-w-full t-max-w-[300px] t-mx-auto"
          >
            <span className="!t-w-full btn btn-custom-secondary !t-rounded-lg">
              {t(Take5MinQuiz)}
            </span>
          </CustomLink>
        </div>
      </div>
    </>
  );
};

export default Products;
